import React from 'react';
import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { StyledMenu } from '../Header.styles';

const user = JSON.parse(localStorage.getItem('user'));
const userRole = user?.role || null;

const menuItems = [
  { key: '/', label: 'Trang chủ' },
  { key: '/about', label: 'Về chúng tôi' },
  { key: '/contact', label: 'Liên hệ' },
  { key: '/list-fitness-center', label: 'Danh sách' },
  { key: '/packages', label: 'Đăng kí thành viên' },

];
if (userRole === "GymOwner" || userRole === "Admin") {
  menuItems.push({ key: '/create-gym', label: 'Tạo phòng Fitness' });
}

const NavMenu = () => {
  const location = useLocation();

  const handleClick = (key) => {
    if (key === '/list-fitness-center' && location.pathname === '/list-fitness-center') {
      // Nếu đang ở cùng route thì reload
      window.location.reload();
    }
  };

  return (
    <StyledMenu
      mode="horizontal"
      selectedKeys={[location.pathname]}
    >
      {menuItems.map(item => (
        <Menu.Item key={item.key} onClick={() => handleClick(item.key)}>
          <Link to={item.key}>{item.label}</Link>
        </Menu.Item>
      ))}
    </StyledMenu>
  );
};

export default NavMenu; 